module.exports = __webpack_public_path__ + "static/img/an_tzjx_icon.png";